import { StyleRules } from '@material-ui/core/styles';
import { ContainerClassKey } from '@material-ui/core';

export const MuiContainer: Partial<StyleRules<ContainerClassKey, Record<string, unknown>>> | undefined = {
  root: {
    '@media (min-width:600px)': {
      paddingLeft: 'unset',
      paddingRight: 'unset',
    },
  },
  maxWidthLg: {
    '@media (min-width:1280px)': {
      maxWidth: 1550,
    },
  },
};
